import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pets_all: FaireCategoryEntity = {
  token: "cat_pets-all",
  type: "category",
  name: "All pets",
  level: 2,
  parentToken: "cat_pets",
  href: "/category/pets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
